import React,{useState,useEffect} from "react";
import fireDb from '../../config.js';
import { useParams,Link } from 'react-router-dom';
import "./View.css"

const View= ()=>{
    const[user,setUser]=useState({});

    const {id}=useParams()
    useEffect(()=>{
        fireDb.child(`contacts/${id}`).get().then((snapshot)=>{
            if(snapshot.exists()){
                setUser({...snapshot.val()})
            }else{
                setUser({})
            }
        })
    },[id]);
    console.log("user",user)
    return(
        <div style={{marginTop:"150px"}}>
        <div className="card">
        <div className="card-header">
         <p>User Contact Detail</p>
        </div>
        <div className="container">
           <strong>ID<span style={{marginLeft:"44px"}}>:</span></strong>
           <span className="strings">{id}</span>
           <br/>
           <br/>
           <strong>Name<span style={{marginLeft:"18px"}}>:</span></strong>
           <span className="strings">{user.name}</span>
           <br/>
           <br/>
           <strong>Email<span style={{marginLeft:"22px"}}>:</span></strong>
           <span className="strings">{user.email}</span>
           <br/>
           <br/>
           <strong>Contact :</strong>
           <span className="strings">{user.contact}</span>
           <br/>
           <br/>
          
        </div>
      <Link to="/">
      <button className="btn btn-edit">Go Back</button>
      </Link>
        </div>
        </div>
    )

}
export default View